import React from "react";
import { Modal, Box } from "@mui/material";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85%",
  minHeight: "45vh",
  maxHeight: "85vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 2,
};

const employeeTrainingRecords = [
  // {
  //   id: 1,
  //   "Employee Name": "Rahul Verma",
  //   "Assigned Date": "10-01-2026",
  //   "Completed Date": "12-01-2026",
  //   "Pre Assessment Score": "8 / 10",
  //   "Post Assessment Score": "9 / 10",
  //   Result: "Pass",
  // },
  {
    id: 2,
    "Employee Name": "Mrs. Anita Sharma",
    "Assigned Date": "11-01-2026",
    "Completed Date": "12-01-2026",
    "Pre Assessment Score": "7 / 10",
    "Post Assessment Score": "9 / 10",
    Result: "Pass",
  },
  {
    id: 3,
    "Employee Name": "Mr. Kiran Patel",
    "Assigned Date": "09-01-2026",
    "Completed Date": "11-01-2026",
    "Pre Assessment Score": "6 / 10",
    "Post Assessment Score": "8 / 10",
    Result: "Pass",
  },
];

const TrainingDetailsModal = ({
  TrainingDetailsModalOpen,
  setTrainingDetailsModalOpen,
  setSelectedRow,
  selectedRow,
  scheduleDetailsInfo,
  setScheduleDetailsInfo,
}) => {
  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "result" && (
          <button
            className={`h-6 w-24 whitespace-nowrap  rounded capitalize px-5 text-center
                   ${
                     row?.result &&
                     (row?.result === "Pass"
                       ? "text-customGreen "
                       : "text-customRed ")
                   }`}
            type="button"
          >
            {row?.result ? row?.result : "-"}
          </button>
        )}
        {header === "preAssessmentScore" && (
          <div>{row?.preAssessmentScore ? row?.preAssessmentScore : "-"}</div>
        )}
        {header === "postAssessmentScore" && (
          <div>{row?.postAssessmentScore ? row?.postAssessmentScore : "-"}</div>
        )}
      </>
    );
  };

  return (
    <Modal open={TrainingDetailsModalOpen}>
      <Box sx={modalStyle}>
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">Training Details</h2>
          <button
            onClick={() => {
              setScheduleDetailsInfo(null);
              setTrainingDetailsModalOpen(false);
              setSelectedRow(null);
            }}
            className="text-gray-500 hover:text-red-500"
          >
            <CloseModalIcon />
          </button>
        </div>

        <div className="col-span-4 mt-3 p-3 border rounded bg-gray-200 text-sm">
          <div className="grid grid-cols-4 gap-2">
            <p>
              <span className="font-semibold">Training Name : </span>
              <span>
                {" "}
                {scheduleDetailsInfo?.trainingDetails?.trainingName}{" "}
              </span>
            </p>

            <p>
              <span className="font-semibold">Date : </span>
              <span>{scheduleDetailsInfo?.trainingDetails?.date}</span>
            </p>
            <p>
              <span className="font-semibold">Mode : </span>
              <span>
                {scheduleDetailsInfo?.trainingDetails?.mode ?? " - "}{" "}
              </span>
            </p>
            <p>
              <span className="font-semibold">Trainer Name : </span>
              <span>
                {" "}
                {scheduleDetailsInfo?.trainingDetails?.trainerName ?? " - "}
              </span>
            </p>
          </div>
        </div>

        <div className="mt-2 overflow-x-auto">
          {scheduleDetailsInfo?.employees?.length > 0 && (
            <CommonTransactionTable
              editableColumns={[
                "result",
                "preAssessmentScore",
                "postAssessmentScore",
              ]}
              renderInput={renderInput}
              dataResult={scheduleDetailsInfo?.employees}
              removeHeaders={["id", "employeeId", "isAttended"]}
              highlightRow={false}
              tableClass="capitalize max-h-[241px] overflow-scroll"
            />
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default TrainingDetailsModal;